import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css'; // Make sure this line is here to apply Tailwind's styles
import { Auth0Provider } from "@auth0/auth0-react";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Auth0Provider
      domain="trendhopper.us.auth0.com"
      clientId="WhE8640Va4p8fTBTL8PfPm0tdqNld6gm"
      authorizationParams={{
        redirect_uri: window.location.origin + '/dashboard'
      }}
    >
    <App/>
  </Auth0Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
